import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, TextField, Typography } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import BrandButtonView from '../../common/BrandButton';
import { formatPortalCopy } from '../../common/formatCopy';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Step 2 Your details: selected-entity card + member basics (demo simplified to five inputs, no validation) */
var MemberDetailsPanel = function MemberDetailsPanel(props) {
  var entity = props.entity,
      email = props.email,
      copy = props.copy,
      submitting = props.submitting,
      onSubmit = props.onSubmit,
      onChangeEntity = props.onChangeEntity,
      onContactBroker = props.onContactBroker;

  var _useForm = useForm({
    defaultValues: {
      firstName: '',
      lastName: '',
      email: email || '',
      phone: '',
      notes: ''
    }
  }),
      control = _useForm.control,
      handleSubmit = _useForm.handleSubmit; // {entityName} is a runtime param (known only after an entity is selected), substituted at render time


  var runtimeParams = {
    entityName: (entity === null || entity === void 0 ? void 0 : entity.name) || ''
  };
  var banner = formatPortalCopy(copy === null || copy === void 0 ? void 0 : copy.banner, runtimeParams);
  var afterSubmitItems = ((copy === null || copy === void 0 ? void 0 : copy.afterSubmitItems) || []).map(function (item) {
    return formatPortalCopy(item, runtimeParams);
  });
  /**
   * methods
   */

  var submitAction = function submitAction() {
    onSubmit();
  };

  var changeEntityAction = function changeEntityAction() {
    onChangeEntity();
  };

  var contactBrokerAction = function contactBrokerAction() {
    onContactBroker === null || onContactBroker === void 0 ? void 0 : onContactBroker();
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: "flex w-full flex-col space-y-6",
    children: [/*#__PURE__*/_jsxs(Box, {
      className: "flex flex-row items-center space-x-4 rounded-2xl border border-black/10 bg-white px-5 py-4",
      children: [/*#__PURE__*/_jsx(Box, {
        className: "flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-[var(--brand-accent)]/10",
        children: /*#__PURE__*/_jsx(Box, {
          component: "svg",
          viewBox: "0 0 24 24",
          className: "h-6 w-6 fill-[var(--brand-accent)]",
          children: /*#__PURE__*/_jsx("path", {
            d: "M4 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v4h2a2 2 0 0 1 2 2v10h-6v-4h-4v4H4zm4-14v2h2V7H8zm0 4v2h2v-2H8zm4-4v2h2V7h-2zm0 4v2h2v-2h-2z"
          })
        })
      }), /*#__PURE__*/_jsxs(Box, {
        className: "flex min-w-0 flex-1 flex-col",
        children: [/*#__PURE__*/_jsx(Typography, {
          className: "truncate text-base font-extrabold text-[var(--brand-primary)]",
          children: entity === null || entity === void 0 ? void 0 : entity.name
        }), /*#__PURE__*/_jsxs(Typography, {
          className: "truncate text-xs text-gray-500",
          children: [entity === null || entity === void 0 ? void 0 : entity.location, entity !== null && entity !== void 0 && entity.location ? ' · ' : '', copy === null || copy === void 0 ? void 0 : copy.agencyTag]
        })]
      }), /*#__PURE__*/_jsx(Typography, {
        className: "cursor-pointer text-sm font-bold text-[var(--brand-accent)] hover:underline",
        onClick: changeEntityAction,
        children: copy === null || copy === void 0 ? void 0 : copy.changeText
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col space-y-5 rounded-2xl border border-black/10 bg-white p-6",
      children: [/*#__PURE__*/_jsx(Typography, {
        className: "text-sm font-extrabold text-[var(--brand-accent)]",
        children: copy === null || copy === void 0 ? void 0 : copy.formTitle
      }), /*#__PURE__*/_jsx(Controller, {
        name: "firstName",
        control: control,
        render: function render(_ref) {
          var field = _ref.field;
          return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, field), {}, {
            fullWidth: true,
            label: copy === null || copy === void 0 ? void 0 : copy.firstNameLabel
          }));
        }
      }), /*#__PURE__*/_jsx(Controller, {
        name: "lastName",
        control: control,
        render: function render(_ref2) {
          var field = _ref2.field;
          return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, field), {}, {
            fullWidth: true,
            label: copy === null || copy === void 0 ? void 0 : copy.lastNameLabel
          }));
        }
      }), /*#__PURE__*/_jsx(Controller, {
        name: "email",
        control: control,
        render: function render(_ref3) {
          var field = _ref3.field;
          return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, field), {}, {
            fullWidth: true,
            label: copy === null || copy === void 0 ? void 0 : copy.emailLabel
          }));
        }
      }), /*#__PURE__*/_jsx(Controller, {
        name: "phone",
        control: control,
        render: function render(_ref4) {
          var field = _ref4.field;
          return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, field), {}, {
            fullWidth: true,
            label: copy === null || copy === void 0 ? void 0 : copy.phoneLabel
          }));
        }
      }), /*#__PURE__*/_jsx(Controller, {
        name: "notes",
        control: control,
        render: function render(_ref5) {
          var field = _ref5.field;
          return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, field), {}, {
            fullWidth: true,
            multiline: true,
            rows: 3,
            label: copy === null || copy === void 0 ? void 0 : copy.notesLabel
          }));
        }
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-row space-x-3 rounded-2xl bg-[var(--brand-accent)]/10 px-5 py-4",
      children: [/*#__PURE__*/_jsx(Box, {
        component: "svg",
        viewBox: "0 0 24 24",
        className: "mt-0.5 h-5 w-5 flex-shrink-0 fill-[var(--brand-accent)]",
        children: /*#__PURE__*/_jsx("path", {
          d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1 5h2v2h-2V7zm0 4h2v6h-2v-6z"
        })
      }), /*#__PURE__*/_jsx(Typography, {
        className: "text-sm leading-6 text-[var(--brand-primary)]",
        children: banner
      })]
    }), /*#__PURE__*/_jsx(BrandButtonView, {
      size: "large",
      className: "w-full",
      disabled: submitting,
      onClick: handleSubmit(submitAction),
      children: copy === null || copy === void 0 ? void 0 : copy.submitText
    }), /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col space-y-4",
      children: [/*#__PURE__*/_jsx(Typography, {
        className: "text-base font-extrabold text-[var(--brand-primary)]",
        children: copy === null || copy === void 0 ? void 0 : copy.afterSubmitTitle
      }), afterSubmitItems.map(function (item, index) {
        return /*#__PURE__*/_jsxs(Box, {
          className: "flex flex-row items-center space-x-3",
          children: [/*#__PURE__*/_jsx(Box, {
            className: "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[var(--brand-accent)]/10",
            children: /*#__PURE__*/_jsx(Box, {
              component: "svg",
              viewBox: "0 0 24 24",
              className: "h-3.5 w-3.5 fill-[var(--brand-accent)]",
              children: /*#__PURE__*/_jsx("path", {
                d: "M9.6 15.6 4.8 10.8l1.4-1.4 3.4 3.4 8-8 1.4 1.4z"
              })
            })
          }), /*#__PURE__*/_jsx(Typography, {
            className: "text-sm leading-6 text-gray-600",
            children: item
          })]
        }, index);
      })]
    }), /*#__PURE__*/_jsxs(Typography, {
      className: "text-center text-sm text-gray-500",
      children: [copy === null || copy === void 0 ? void 0 : copy.contactHint, ' ', /*#__PURE__*/_jsx(Typography, {
        component: "span",
        className: "cursor-pointer text-sm font-bold text-[var(--brand-accent)] hover:underline",
        onClick: contactBrokerAction,
        children: copy === null || copy === void 0 ? void 0 : copy.contactLinkText
      })]
    })]
  });
};

export default MemberDetailsPanel;